import './styles';
import type { Dataset } from '../import/types';
import { showImport } from './import-view';
import { hideReport, SAMPLE_RUNNERS, showReport } from './report-view';
import { deleteSaved, loadDataset, saveDataset } from './saved';

/* Two screens: import, then report. The dataset lives in this page's memory, and on this device
 * only if the runner chose "Remember on this device". */
let data: Dataset | null = null, saved = false;

const mine = (d: Dataset) => showReport([{ id: 'me', name: 'You', data: d }], saved ? 'Your data · saved on this device' : 'Your data · stays in this browser', {
  saved,
  onDeleteSaved: async () => { if (!confirm('Delete the poster data saved on this device?')) return; await deleteSaved(); saved = false; mine(d); },
});

/* Go to a screen. Setting the same hash fires no 'hashchange', so route directly in that case (e.g. a
 * page reloaded at #report, then imported: the report must still open). */
const goTo = (hash: string) => { if (location.hash === hash) route(); else location.hash = hash; };

async function route() {
  const h = location.hash;
  // development only (removed from the production build): load a prepared private dataset
  if (import.meta.env.DEV && h.startsWith('#dev=')) { fetch(`/prototypes/private/${h.slice(5)}.json`).then((r) => r.json()).then((d: Dataset) => { data = d; mine(d); }); return; }
  if (h === '#report' && data) return mine(data);
  if (h === '#sample') return showReport(SAMPLE_RUNNERS, 'Sample runner');
  // a reloaded #report or #… with nothing to show: drop the stale hash, show the import screen
  if (h && !h.startsWith('#dev=')) history.replaceState(null, '', location.pathname + location.search);
  hideReport();
  const stored = await loadDataset();
  showImport({
    saved: stored,
    onData: async (d, remember, note) => {
      data = d;
      saved = remember && (await saveDataset(d));
      goTo('#report');
      if (note) setTimeout(() => alert(note), 50);
      if (remember && !saved) setTimeout(() => alert('This browser wouldn’t let the poster be saved (private browsing, or storage turned off). It stays open until you close the page.'), 50);
    },
    onSample: () => goTo('#sample'),
    onOpenSaved: () => { data = stored; saved = true; goTo('#report'); },
    onDeleteSaved: async () => { await deleteSaved(); saved = false; route(); },
  });
}
window.addEventListener('hashchange', () => { route(); });
document.getElementById('home')!.addEventListener('click', (e) => { e.preventDefault(); if (location.hash) location.hash = ''; else route(); });
route();

// works offline once loaded (production builds only)
if (import.meta.env.PROD && 'serviceWorker' in navigator) navigator.serviceWorker.register('./sw.js').catch(() => {});
